import { createContext, useContext } from "react";

export interface ArraySubFormContextType {
  fields: { id: string }[];
  append: (newItem: any) => void;
  remove: (index: number) => void;
}

export const ArraySubFormContext =
  createContext<ArraySubFormContextType | null>(null);

export const useArraySubFormContext = () => {
  const ctx = useContext(ArraySubFormContext);
  if (!ctx)
    throw new Error(
      "ArraySubForm components must be used inside ArraySubFormProvider"
    );
  return ctx;
};
